// Copyright (c) 2022 by Move Closer

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface IPrivacyManager {
  isEnabled: boolean
  options: string[]
  requiredOptions: string[]
  clearPreferences (): void
  getPreferences (): PreferenceRecord
  getValueOf (key: string): boolean
  hasAllPreferencesSet (): boolean
  setPreferences (preferences: PreferenceRecord): void
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const IPrivacyManagerType = Symbol.for('IPrivacyManager')

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export type PreferenceRecord = Record<string, boolean | null>

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface PrivacyConfig {
  enabled: boolean
  options: string[]
  required: string[]
}

export enum PrivacyOptions {
  Required = 'required',
  Functional = 'functional',
  Analytics = 'analytics',
  Marketing = 'marketing'
}
